import styled from 'styled-components';
import { RadioGroup } from '@lendi-ui/radio';
import { mb, ml, mt } from '@lendi-ui/spacing';

interface CustomizedRadio {
  noVerticalSpace?: boolean;
}

// Lui's Radio group contain a Legend element, which is not used in funnels but it
// displays with space. So just remove it.
// Also confirmed with Nico, he prefer to fix this among all usages.
export const StyledRadioGroup = styled(RadioGroup)`
  legend {
    display: none;
  }
`;

export const RadioButton = styled(RadioGroup.Radio)`
  ${mb('nil')}
`;

export const RadioButtonBlock = styled(RadioButton)<CustomizedRadio>`
  ${({ noVerticalSpace }) => !noVerticalSpace && mt('sm')}

  &:first-child {
    ${mt('nil')}
  }
`;

export const RadioButtonInline = styled(RadioButton)<CustomizedRadio>`
  ${ml('sm')}

  &:first-child {
    ${ml('nil')}
  }
`;
